import { render, staticRenderFns } from "./am5PercentChart.vue?vue&type=template&id=e220e1e2&scoped=true"
import script from "./am5PercentChart.vue?vue&type=script&lang=js"
export * from "./am5PercentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220e1e2",
  null
  
)

export default component.exports